// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface";

const Datatable: React.FC<DatatableProps> = ({ 
  columns, 
  dataSource, 
  Selection, 
  refresh, 
  rowSelection, 
  selectedRowKeys: parentSelectedRowKeys, 
  onRowSelectionChange, 
  showSearch = true,
  defaultSearchText,
  showTableTopData = true,
  rowKey,
  onRow
}) => {
  const [localSelectedRowKeys, setLocalSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>();
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  useEffect(() => {
    handleSearch(defaultSearchText || "");
  }, [dataSource, defaultSearchText]);

  // Synchronize localSelectedRowKeys with parentSelectedRowKeys
  useEffect(() => {
    if (parentSelectedRowKeys) {
      setLocalSelectedRowKeys(parentSelectedRowKeys);
    }
  }, [parentSelectedRowKeys]);

  // Handle row selection changes
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setLocalSelectedRowKeys(newSelectedRowKeys); // Update local state
    if (onRowSelectionChange) {
      onRowSelectionChange(newSelectedRowKeys); // Notify parent
    }
    if (rowSelection?.onChange) {
      rowSelection.onChange(newSelectedRowKeys, []); // Call parent-provided onChange
    }
  };

  // Merge local rowSelection with parent-provided rowSelection
  const mergedRowSelection = {
    selectedRowKeys: localSelectedRowKeys,
    onChange: onSelectChange,
    ...rowSelection, // Allow parent to override rowSelection properties
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource?.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  useEffect(() => {
    return setSelections(Selection);
  }, [Selection]);

  return (
    <>
      <div className="table-top-data" hidden={!showTableTopData}>
        <div className="row p-3">
          <div className="col-sm-12 col-md-6">
            <div className="dataTables_length" id="DataTables_Table_0_length"></div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div
              id="DataTables_Table_0_filter"
              className="dataTables_filter text-end mb-0 justify-content-end d-flex align-items-center"
            >
              {refresh && (
                <div
                  className="refresh-icon-container me-2"
                  onClick={refresh}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    width: "2.0rem",
                    height: "2.0rem",
                    backgroundColor: "#f1f1f1", // Light background for better visibility
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e0e0e0")
                  } // Hover effect
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f1f1f1")
                  }
                  title="Refresh Data" // Tooltip for better UX
                >
                  <i
                    className="fa fa-sync text-primary"
                    style={{
                      fontSize: "1.3rem",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "rotate(90deg)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "rotate(0deg)")
                    }
                  />
                </div>
              )}

              <label hidden={!showSearch}>
                {" "}
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  aria-controls="DataTables_Table_0"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
      </div>

      {!Selections ? (
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          dataSource={filteredDataSource}
          rowKey={rowKey}
          onRow={onRow}
          pagination={{
            hideOnSinglePage: true,
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right"/>,
            prevIcon: <i className="ti ti-chevron-left"/>,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
        />
      ) : (
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={Selection ? mergedRowSelection : undefined}
          columns={columns}
          dataSource={filteredDataSource}
          rowKey={rowKey}
          onRow={onRow}
          pagination={{
            hideOnSinglePage: true,
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
            showTotal: (total, range) =>
              `${range[0]} - ${range[1]} of ${total}`,
          }}
        />
      )}
    </>
  );
};

export default Datatable;
